import { ListboxOption } from '@headlessui/react'
import { useUIComponentsContext } from '../../Provider/UiComponentsProvider'

const DropdownListNoDataOption = () => {
  const { t } = useUIComponentsContext()

  return (
    <ListboxOption
      disabled
      className="cursor-default select-none relative p-3"
      value={'No data'}
    >
      <span className="block truncate text-xs text-oxford-gray-800">
        {t('expressions.noDataAvailable')}
      </span>
    </ListboxOption>
  )
}

export default DropdownListNoDataOption
